import { Search, Filter, X } from 'lucide-react';

interface LeadFiltersProps {
  searchQuery: string;
  onSearchChange: (q: string) => void;
  activeFilters: string[];
  onToggleFilter: (filter: string) => void;
}

const QUICK_FILTERS = [
  { key: 'noEmail', label: 'Manque email' },
  { key: 'topOnly', label: 'Top contacts' },
  { key: 'france', label: 'France' },
  { key: 'new', label: 'Nouveau' },
  { key: 'contacted', label: 'Contacte' },
  { key: 'replied', label: 'Repondu' },
  { key: 'meeting', label: 'RDV' },
  { key: 'deal', label: 'Deal' },
];

export default function LeadFilters({ searchQuery, onSearchChange, activeFilters, onToggleFilter }: LeadFiltersProps) {
  return (
    <div className="space-y-3">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Rechercher par entreprise, contact, poste..."
          className="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
        />
        {searchQuery && (
          <button onClick={() => onSearchChange('')} className="absolute right-3 top-1/2 -translate-y-1/2">
            <X className="w-4 h-4 text-gray-400 hover:text-gray-600" />
          </button>
        )}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <Filter className="w-4 h-4 text-gray-400" />
        {QUICK_FILTERS.map((f) => (
          <button
            key={f.key}
            onClick={() => onToggleFilter(f.key)}
            className={`px-3 py-1 text-xs rounded-full border transition-colors ${
              activeFilters.includes(f.key)
                ? 'bg-blue-600 text-white border-blue-600'
                : 'bg-white text-gray-600 border-gray-200 hover:border-gray-300'
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>
    </div>
  );
}
